import { render, staticRenderFns } from "./RentalRequestsList.vue?vue&type=template&id=6bfc8a5e&scoped=true&"
import script from "./RentalRequestsList.vue?vue&type=script&lang=ts&"
export * from "./RentalRequestsList.vue?vue&type=script&lang=ts&"
import style0 from "./RentalRequestsList.vue?vue&type=style&index=0&id=6bfc8a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc8a5e",
  null
  
)

export default component.exports